import { h } from 'preact';
import cx from 'classnames';
import CandidateRow from './CandidateRow';

const EmptyTable = ({ party }) => {
  const rowClass = cx('seat__race', {
    'seat__race--Democrat': party == 'Democrat',
    'seat__race--Republican': party == 'Republican',
  });
  return (
    <div class={rowClass}>
      <div class="race">
        <span>
          <h4 class="race__title">{party} </h4>
        </span>
      </div>
      <table class="race__candidates">{CandidateRow.Header}</table>
      <div class="no_primary no_primary_candidates">
        No primary candidates running
      </div>
    </div>
  );
};

export default EmptyTable;
